import { render } from "./collectCenter.vue?vue&type=template&id=220e72a4&scoped=true"
import script from "./collectCenter.vue?vue&type=script&lang=js"
export * from "./collectCenter.vue?vue&type=script&lang=js"

import "./collectCenter.vue?vue&type=style&index=0&id=220e72a4&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-220e72a4"]])

export default __exports__